<div class="static-form"
     [class.text-center]="getAlignClass(align)"
     [class.text-right]="getAlignClass(align)"
>
    <div class="label">{{ label }}</div>
    <p class="form-control-static">
        <ng-content></ng-content>
    </p>
</div>
